import React, { useEffect, useState } from 'react';
import { BookmarkIcon } from '@heroicons/react/outline';
import { isSaved, onSavedChange, toggleSaved } from '../utils/savedJobs';

// Save / unsave a job on this device (feature "savedJobs"). `job` is the card's fields with `id`.
// One icon in both states (outline, filled when saved) so nothing changes size; the labelled
// button keeps a fixed width so "Save" → "Saved" doesn't shift its neighbours.
export default function SaveButton({ job, withLabel = false, className = '' }) {
  const [saved, setSaved] = useState(() => isSaved(job.id));
  useEffect(() => {
    setSaved(isSaved(job.id));
    return onSavedChange(() => setSaved(isSaved(job.id)));
  }, [job.id]);
  const look = withLabel
    ? `min-w-[6.5rem] justify-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold ${
        saved ? 'border-primary bg-primary-light text-primary-dark' : 'border-gray-200 bg-white text-gray-600 hover:border-primary hover:text-primary-dark'
      }`
    : `h-10 w-10 justify-center rounded-full ${saved ? 'bg-primary-light text-primary-dark' : 'text-gray-400 hover:bg-gray-100 hover:text-primary-dark'}`;
  return (
    <button
      type="button"
      aria-pressed={saved}
      aria-label={withLabel ? undefined : saved ? `Remove ${job.title} from saved jobs` : `Save ${job.title}`}
      title={withLabel ? undefined : saved ? 'Saved' : 'Save job'}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setSaved(toggleSaved(job));
      }}
      className={`inline-flex items-center transition active:scale-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${look} ${className}`}
    >
      <BookmarkIcon className="h-5 w-5 flex-shrink-0" fill={saved ? 'currentColor' : 'none'} aria-hidden="true" />
      {withLabel && <span>{saved ? 'Saved' : 'Save'}</span>}
    </button>
  );
}
